<template>
  <div>
    <b-row>
      <b-col md="4" cols="12">
        <info-card label="نوع الفعالية"
          :value="data.event_type"
        />
      </b-col>
      
      <b-col md="4" cols="12">
            <ShowSessionMinutesFile :data='data.meeting_minute_id' message="" />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="تاريخ بدء الفعالية"
          :value="data.start_date"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="تاريخ نهاية الفعالية"
          :value="data.end_date"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="الدولة"
          :value="data.country_id ? data.country_id.name :''"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label=" العنوان"
          :value="data.address"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="الجهة المنظمة للفعالية"
          :value="data.organiser"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="الهدف من الفعالية"
          :value="data.objective"
        />
      </b-col>
      <b-col md="4" cols="12" v-if="data.hasOwnProperty('other_invited_parties') ">
        <info-card label="الجهات الإخرى المدعوة للفعالية"
          :value="data.other_invited_parties"
        />
      </b-col>
      <b-col cols="4">
        
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              صورة عن الدعوة
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.invitation_file } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
  
  import ShowSessionMinutesFile from './ShowSessionMinutesFile.vue'
export default {
  components: {
    BCard, BImg , BCol , InfoCard , BRow , BButton, ShowSessionMinutesFile
  },
  props: {
    data : Object ,
  },

  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
};
</script>